import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';



@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor() {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
      //console.log("request : "+JSON.stringify(request));
        return next.handle(request).pipe(catchError(err => {
          console.log(JSON.stringify(err));
            if (err.status === 401) {
                // auto logout if 401 response returned from api


            }

          //  const error = err.error.message || err.statusText;
            return throwError(err);
        }))
    }
}
